export const fromObjToString = (obj, CurrEnum) =>
	Object.entries(obj)
		.reduce((acc, [key, val]) => {
			if (!CurrEnum[key]) return acc;
			if ((typeof val === 'boolean' && val) || (typeof val === 'string' && val.toLowerCase() === 'yes'))
				return [...acc, CurrEnum[key] as string];
			return acc;
		}, [] as string[])
		.join(', ');
